import React from "react";
import { clsx } from "clsx";
import { graphql, useStaticQuery } from "gatsby";
import Category from "./Category";
import Section from "./Section";
import Footer from "./Footer";
import Tag from "./Tag";

interface IDrawerProps extends React.PropsWithChildren {
  isDrawerOpen: boolean;
}

export default function Drawer(props: IDrawerProps) {
  const { isDrawerOpen } = props;

  const data = useStaticQuery(graphql`
    query {
      categories: allMicrocmsCategory(sort: { publishedAt: DESC }) {
        edges {
          node {
            categoryId
            id
            name
          }
        }
      }

      tags: allMicrocmsTag(sort: { publishedAt: DESC }) {
        edges {
          node {
            id
            name
            tagId
          }
        }
      }
    }
  `);

  if (!isDrawerOpen) {
    return null;
  }

  return (
    <nav className={clsx("pb-12", "w-full", "z-10")}>
      <div
        className={clsx(
          "bg-primary",
          "flex",
          "flex-col",
          "items-center",
          "pt-2",
          "px-8",
          "space-y-4",
          "text-primary-content",
        )}
      >
        <Section primaryContent headline="カテゴリー">
          <div className={clsx("gap-8", "grid", "grid-cols-3")}>
            {data.categories.edges.map(
              (category: Queries.MicrocmsCategoryEdge) => {
                return (
                  <Category
                    key={category.node.id}
                    name={category.node.name ?? ""}
                    categoryId={category.node.categoryId ?? ""}
                    primaryContent
                  />
                );
              },
            )}
          </div>
        </Section>
        <Section primaryContent headline="タグ">
          <div className={clsx("gap-2", "grid", "grid-cols-2")}>
            {data.tags.edges.map((tag: Queries.MicrocmsTagEdge) => {
              return (
                <Tag
                  key={tag.node.id}
                  name={tag.node.name ?? ""}
                  tagId={tag.node.tagId ?? ""}
                />
              );
            })}
          </div>
        </Section>
      </div>
      <Footer />
    </nav>
  );
}
